export class CharCode {
  static zero = 48
  static nine = 57
  static dote = 46
  static comma = 47
}
